"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRightHeartCatherization = createRightHeartCatherization;
const events_1 = require("../../../events");
const rightHeartCatheterization_1 = require("../../../forms/htx/current-cardiological-state/rightHeartCatheterization");
const queries_1 = require("../queries");
const messages = {
    rightHeartCatheterization: {
        id: "dashboard.right_heart_catheterization",
        defaultMessage: "Jobbszívfél-katéterezés"
    },
    measuredValue: {
        id: "dashboard.measured_value",
        defaultMessage: "Vizsgált érték"
    },
    baseLine: {
        id: "dashboard.right_heart_catheterization.baseline",
        defaultMessage: "Baseline"
    },
    postVrt: {
        id: "dashboard.right_heart_catheterization.post_vrt",
        defaultMessage: "PostVRT"
    },
    rrs: {
        id: "dashboard.rrs",
        defaultMessage: "RRs"
    },
    hr: {
        id: "dashboard.hr",
        defaultMessage: "HR"
    },
    cvp: {
        id: "dashboard.cvp",
        defaultMessage: "CVP (Rap)"
    },
    svO2: {
        id: "dashboard.svo2",
        defaultMessage: "SvO2"
    },
    rvps: {
        id: "dashboard.rvps",
        defaultMessage: "RVPs"
    },
    rvpd: {
        id: "dashboard.rvpd",
        defaultMessage: "RVPd"
    },
    rvpm: {
        id: "dashboard.rvpm",
        defaultMessage: "RVPm"
    },
    paps: {
        id: "dashboard.paps",
        defaultMessage: "PAPs"
    },
    papd: {
        id: "dashboard.papd",
        defaultMessage: "PAPd"
    },
    mpap: {
        id: "dashboard.mpap",
        defaultMessage: "mPAP"
    },
    mpcwp: {
        id: "dashboard.mpcwp",
        defaultMessage: "mPCWP"
    },
    co: {
        id: "dashboard.co",
        defaultMessage: "CO"
    },
    ci: {
        id: "dashboard.ci",
        defaultMessage: "CI"
    },
    tpg: {
        id: "dashboard.tpg",
        defaultMessage: "TPG"
    },
    pvr: {
        id: "dashboard.pvr",
        defaultMessage: "PVR"
    }
};
function createRightHeartCatherization({ formatMessage, formatMessageMap, formatNumber }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.rightHeartCatheterization);
    if (event === undefined) {
        return undefined;
    }
    const { value, timestamp, sid, origin } = event;
    const v = JSON.parse(JSON.stringify(value));
    delete v.vasoreactivityTest;
    let columns;
    let rows;
    if (value.vasoreactivityTest === rightHeartCatheterization_1.VasoreactivityTest.NO) {
        columns = [
            formatMessage(messages.measuredValue),
            formatMessage(messages.baseLine)
        ];
        rows = Object.entries(v).map(([key, { value }]) => {
            return [
                formatMessageMap(messages, key),
                value === undefined ? "-" : formatNumber(value)
            ];
        });
    }
    else {
        columns = [
            formatMessage(messages.measuredValue),
            formatMessage(messages.baseLine),
            formatMessage(messages.postVrt)
        ];
        rows = Object.entries(v).map(([key, { value, postVrt }]) => {
            return [
                formatMessageMap(messages, key),
                value === undefined ? "-" : formatNumber(value),
                postVrt === undefined ? "-" : formatNumber(postVrt)
            ];
        });
    }
    return {
        type: "table",
        label: formatMessage(messages.rightHeartCatheterization),
        attachments: (0, events_1.mapEventsToAttachments)(event),
        columns,
        rows,
        timestamp,
        sid,
        origin
    };
}
